import { createComponent } from '@lit/react';
import React from 'react';
import { SDSSwitch } from '../sds-switch/sds-switch';
import { SheriffEventName } from './types';

export const SDSSwitchWrapper = createComponent({
	tagName: 'sds-switch',
	elementClass: SDSSwitch,
	react: React,
	events: {
		onChange: 'change' as SheriffEventName,
		onFocus: 'focus' as SheriffEventName,
		onBlur: 'blur' as SheriffEventName,
	},
});
